import React from 'react'

const Gallery = () => {
    return (
        <>

            <div>
                <section className="inner-banner">
                    <h1 className="font-weight-bold text-center"><b>Gallery</b></h1>
                </section>
                <section className="course">
                    <div className="container">
                        <div className="sec-title text-center mb-3" data-aos="fade-up" data-aos-duration={1000}>
                            <span className="title">Our Gallery</span>
                            <h2>Life At Campus</h2>
                            <div className="divider">
                                <span className="fa fa-mortar-board" />
                            </div>
                        </div>
                        <ul className="nav nav-pills mb-3 p-0 justify-content-center" id="pills-tab" role="tablist" data-aos="fade-up" data-aos-duration={1000}>
                            <li className="nav-item">
                                <a className="nav-link active" id="showall-tab" data-bs-toggle="pill" href="#showall" role="tab" aria-controls="showall" aria-selected="true">Show All</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="Events-tab" data-bs-toggle="pill" href="#Events" role="tab" aria-selected="false">Events</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" id="Sports-tab" data-bs-toggle="pill" href="#Sports" role="tab" aria-selected="false">Sports</a>
                            </li>
                            {/* <li className="nav-item">
                                <a className="nav-link" id="Classroom-tab" data-bs-toggle="pill" href="#Classroom" role="tab" aria-selected="false">Classroom</a>
                            </li> */}
                        </ul>
                        <div className="row">
                            <div className="tab-content" id="pills-tabContent">

                                {/* start Show All */}
                                {/* 2025 */}

                                <div className="tab-pane  fade show active" id="showall" role="tabpanel" aria-labelledby="showall-tab">
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/32.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/32.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/33.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/33.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/34.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/34.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/35.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/35.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/36.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/36.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/37.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/37.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/38.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/38.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/39.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/39.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/40.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/40.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/41.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/41.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>

                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/42.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/42.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/43.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/43.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/44.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/44.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/45.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/45.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/46.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/46.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/47.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/47.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/48.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/48.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/49.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/49.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/50.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/50.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/51.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/52.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/53.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/53.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/54.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/54.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/55.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/55.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/56.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/56.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>

                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/57.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/58.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/203.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/203.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/60.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/60.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/202.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/202.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/62.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/62.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/63.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/63.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                </div>


                                <div className="tab-pane  fade show active" id="showall" role="tabpanel" aria-labelledby="showall-tab">
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/64.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/64.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/65.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/65.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/66.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/66.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/67.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/67.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/68.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/68.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/69.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/69.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/70.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/70.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/71.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/71.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/201.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/201.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/73.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/73.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>

                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/74.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/74.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/75.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/75.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/76.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/76.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/77.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/77.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/78.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/78.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/79.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/79.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/80.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/80.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/81.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/81.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/82.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/82.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/83.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/83.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/84.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/84.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/85.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/85.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/86.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/86.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/87.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/87.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>

                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/88.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/88.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/89.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/89.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/90.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/90.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/91.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/91.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/92.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/92.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/153.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/153.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                </div>
                                


                                {/* 2024 */}
                                <div className="tab-pane  fade show active" id="showall" role="tabpanel" aria-labelledby="showall-tab">
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/1.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/1.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/2.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/2.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/3.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/3.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/4.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/4.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/5.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/5.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/6.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/6.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/7.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/7.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/8.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/8.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/9.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/9.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/10.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/10.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>

                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/11.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/11.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/12.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/12.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/13.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/13.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/14.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/14.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/15.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/15.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/16.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/16.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/17.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/17.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/18.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/18.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/19.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/19.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/20.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/20.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/21.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/21.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/22.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/22.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/23.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/23.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/24.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/24.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>

                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/25.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/25.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/26.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/26.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/27.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/27.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/28.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/29.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/30.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/30.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/31.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/31.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                </div>
                                {/* end Show All */}

                                <div className="tab-pane  fade" id="Events" role="tabpanel" aria-labelledby="Events-tab">
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/1.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/1.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/2.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/2.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/3.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/3.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/4.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/5.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/5.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/6.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/6.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/7.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/7.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/8.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/8.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/9.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/9.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/10.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/10.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>




                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/11.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/11.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid " src="assets/images/2025/Gallery/12.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/12.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="img-fluid" src="assets/images/2025/Gallery/13.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/13.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/14.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/14.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/15.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/15.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/16.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/16.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/17.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/17.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/18.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/18.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/19.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/19.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/20.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/20.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/21.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/21.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/22.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/22.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/23.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/23.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/24.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/24.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Event</h5>
                                        </div>
                                    </div>
                                </div>
                                {/* Gallery sport */}

                                <div className="tab-pane fade" id="Sports" role="tabpanel" aria-labelledby="Sports-tab">
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/24.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/24.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/26.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/26.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/27.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/27.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/28.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/28.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/29.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/29.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/30.webp" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/30.webp" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Sports</h5>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className="tab-pane fade" id="Classroom" role="tabpanel" aria-labelledby="Classroom-tab">
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/114.JPG" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/1.JPG" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Classroom</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/114.JPG" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/114.JPG" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Classroom</h5>
                                        </div>
                                    </div>
                                    <div className="Portfolio" data-aos="fade-up" data-aos-duration={1000}>
                                        <img className="card-img" src="assets/images/2025/Gallery/114.JPG" alt="Gallery" />
                                        <div className="overlay" />
                                        <div className="overlay-text">
                                            <a href="assets/images/2025/Gallery/114.JPG" data-fancybox="gallery">
                                                <i className="fa fa-plus fa-2x" />
                                            </a>
                                            <h5 className="font-weight-bold">Classroom</h5>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    )
}

export default Gallery